import * as angular from "angular";
import {IController} from "angular";

export class DeliveriesSmsMessagesViewComponent implements IController {

  referenceId: any;

  public loadLimit: any;
  public deliveriesMessagesRef: any;
  public infiniteScroll: any;

  constructor(private $deliveriesMessages, private $infiniteScroll) {
  }

  $onInit() {
    this.loadLimit = 50;
    this.deliveriesMessagesRef = this.$deliveriesMessages();

    this.deliveriesMessagesRef.$query(this._getQueryPayload());
    this.infiniteScroll = this.$infiniteScroll(this.deliveriesMessagesRef, this.loadLimit, {getFullData: true});
  }

  _getQueryPayload() {
    return {
      limit: this.loadLimit,
      referenceId: this.referenceId,
    }
  }

}

angular
  .module('bringoz.admin.deliveries')
  .component('deliveriesSmsMessagesView', {
    bindings: {
      referenceId: '<',
    },
    template: require('./deliveries-sms-messages-view.html').default,
    controller: DeliveriesSmsMessagesViewComponent,
  });
